import { applyMiddleware, compose, createStore } from 'redux';
import { persistReducer, persistStore } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import createSagaMiddleware from 'redux-saga';
import { promiseMiddleware } from 'redux-saga-promise-actions';

import rootReducer from './reducers';
import rootSaga from './sagas';

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const persistConfig = {
  key: 'gipsyy-europe',
  storage,
  whitelist: ['search', 'tripDetails'],
  // testei tirar payments e trips
  // whitelist: ['search', 'trips', 'payments'],
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

const sagaMiddleware = createSagaMiddleware();
const middlewares = [promiseMiddleware, sagaMiddleware];

const store = createStore(persistedReducer, composeEnhancers(applyMiddleware(...middlewares)));
export const persistor = persistStore(store);

export default store;

sagaMiddleware.run(rootSaga);
